import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ListiniApi, GetListiniMangimiRequest } from "../data/apis/ListiniApi";

export function listiniMangimiDataSource(idFiliera: number, showAll: boolean) {
     return new CustomStore({
            key: "id",
            loadMode : 'raw',
            load: (loadOptions) => {
                const api = new ListiniApi(apiConfiguration);
    
                const request: GetListiniMangimiRequest = {
                    idFiliera: idFiliera,
                };
    
                return api.getListiniMangimi(request);
            },

            byKey: (key) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListinoMangimiById({
                idListino: key
            });
        },
    
            insert: (values) => {
                const api = new ListiniApi(apiConfiguration);
    
                return api.insertListinoMangimi({
                    listinoCreateDTO: values
                });
            },
    
            update: async (key: any) => {},
            remove: async (key: any) => {},
    
        });
    }